<template>
    <span>
        <currency-input v-model="range.start" :class-name="'text-input'"></currency-input>
        <div class="separator">-</div>
        <currency-input v-model="range.end" :class-name="'text-input'"></currency-input>
        <a v-show="showRemove" v-on:click.prevent="remove" class="remove"><i class="fa fa-close"></i></a>
        <slot></slot>
    </span>
</template>

<script>
    export default {
        props: ['range', 'showRemove'],

        methods: {
            remove() {
                this.$emit('remove');
            }
        }
    }
</script>